import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiGqlClient } from "~/libs/gql";
import { graphql } from "~/types/__generated/gql";
import {
	UpdateReceiptPaymentMutation,
	UpdateReceiptPaymentMutationVariables,
} from "~/types/__generated/gql/graphql";
import { getFileByIdQueryKey } from "../useGetFileById";

const query = /* GraphQL */ `
	mutation UpdateReceiptPayment(
		$id: ObjectID!
		$input: UpdateReceiptPaymentInput!
	) {
		updateReceiptPayment(id: $id, input: $input) {
			_id
		}
	}
`;

export type UpdateReceiptPaymentVariables =
	UpdateReceiptPaymentMutationVariables;
export type UpdateReceiptPaymentResults =
	UpdateReceiptPaymentMutation["updateReceiptPayment"];

export const useUpdateReceiptPayment = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (variables: UpdateReceiptPaymentVariables) =>
			apiGqlClient
				.request(graphql(query), variables)
				.then((res) => res.updateReceiptPayment),
		onSuccess: ({ _id }) => {
			void queryClient.invalidateQueries(getFileByIdQueryKey(_id));
		},
	});
};
